module.exports = __webpack_public_path__ + "static/media/client_site_view.5e874fb1.svg";